export default __webpack_public_path__ + "static/media/people.b54a8384.png";